import token from '@uipath/apollo-core/lib';
export const MuiFormHelperText = (palette) => {
    return {
        sizeSmall: { fontSize: token.FontFamily.FontXsSize },
        root: {
            fontSize: token.FontFamily.FontSSize,
            lineHeight: 1.5,
            color: palette.semantic.colorForegroundDeEmp,
            marginLeft: 0,
            marginTop: '4px',
            '&.Mui-error': { color: palette.semantic.colorErrorText },
            '&.Mui-disabled': {
                display: 'none',
                color: palette.semantic.colorForegroundDisable,
            },
        },
    };
};
